import Vue from 'vue'
import { Validator } from 'vee-validate'

Validator.extend('password', {
  getMessage: field => 'Password must contain a lowercase letter, an uppercase letter, a number, and be at least 8 characters.',
  validate: value => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(value)
})

Validator.extend('phone', {
  getMessage: field => `The ${field} must be a valid phone number.`,
  validate: value => /^(\d|\+)[0-9]{9,12}$/.test(value)
})

Validator.extend('mobile', {
  getMessage: field => `The ${field} must be a valid Australian mobile number.`,
  validate: value => /^(04|\+614)[0-9]{8}$/.test(value)
})

Validator.extend('alpha_numeric_spaces', {
  getMessage: field => `The ${field} may only contain alphanumeric characters and spaces.`,
  validate: value => /^[A-Za-z0-9\s]*$/.test(value)
})

Vue.mixin({
  methods: {
    async _validate () {
      const valid = await this.$validator.validate(...arguments)

      return valid
    },

    errorClass (field) {
      return { 'is-invalid': this.errors.has(field) }
    }
  }
})
